import React from 'react';
import { ShieldCheck, FileCheck2, ScrollText } from 'lucide-react';

const LocalFirst = () => {
  return (
    <section id="local-first" className="my-20">
      <div className="bg-gradient-to-br from-apple-800/60 to-apple-900/60 backdrop-blur-md rounded-3xl border border-apple-700/40 p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -left-32 -top-32 w-72 h-72 rounded-full bg-sortio-primary/10 blur-[100px]" />
        <div className="absolute -right-32 -bottom-32 w-72 h-72 rounded-full bg-sortio-secondary/10 blur-[100px]" />

        <div className="relative z-10">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-4">
              <ShieldCheck className="text-sortio-primary" size={22} />
            </div>
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Privacy by design
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-semibold mb-6 tracking-tight text-apple-50 max-w-3xl">
            Keep client work on your machine, on your terms
          </h2>

          <div className="max-w-3xl space-y-5 text-apple-200 leading-relaxed">
            <p>
              Sortio reads files on your Mac or PC. When it opens a grant narrative or a draft
              contract to extract the client name and project code, that read happens locally.
              In Offline mode with a local LLM (Ollama), nothing leaves your machine at all. With
              Bring Your Own Key, requests go from your machine directly to your own provider
              under your account. Your Dropbox stays your Dropbox.
            </p>
            <p>
              By default Sortio uses our cloud (OpenAI) to plan the sort, sending filenames and
              folder paths; file contents are sent only if you enable a content-based feature
              like AI rename by content or knowledge-graph indexing. For consultants under NDA
              and founders handling compliance work who need content to stay on device, choose
              Offline (Ollama) or BYOK, and no client draft passes through a Sortio cloud step.
              All traffic is encrypted in transit (TLS 1.2+) and at rest.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <FileCheck2 className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Works with your cloud sync</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Sortio works on Dropbox, OneDrive, iCloud Drive, Google Drive, and any folder
                that syncs locally. No accounts to connect, no API keys to manage. Point it at
                the folders you already use.
              </p>
            </div>

            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <ScrollText className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Audit trail</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Every move is logged locally with the source path, destination, and the AI's
                confidence score. If a deliverable lands under the wrong client, you can trace
                exactly what happened and undo it in one click.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalFirst;
